<template>
  <div>
    <div class="d-flex justify-content-between align-self-center my-4">
      <span class="title">申請人資料</span>
    </div>
    <AGCEditGroupInput v-if="role === 'admin'"
                       v-model="inputVal.accTypeInRegister"
                       :fieldName="'accTypeInRegister'"
                       :options="classOptions"
                       :inputType="'dropdown'"
                       label="用戶要求級別"
                       name="用戶要求級別"
                       disabled
                       :readOnly="readOnly || role !== 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.class"
                       :fieldName="'class'"
                       :options="classOptions"
                       :inputType="'dropdown'"
                       label="帳戶級別"
                       name="帳戶級別"
                       rules="required"
                       class="custom-dropdown"
                       disabled
                       required
                       :readOnly="readOnly || inputVal.class !== 'NORMAL' || role !== 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.username"
                       :fieldName="'username'"
                       label="帳戶名稱"
                       name="帳戶名稱"
                       rules="required|username|max:15"
                       type="text"
                       disabled
                       required
                       :readOnly="readOnly || role !== 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.contactEmail"
                       :inputType="'formTag'"
                       :fieldName="'contactEmail'"
                       label="聯絡電郵"
                       name="聯絡電郵"
                       placeholder="可輸入多個聯絡電郵，請按Enter 分隔聯絡電郵"
                       :validate-reg-ex="regEx"
                       rules="required|maxArray:10"
                       type="text"
                       disabled
                       required
                       :readOnly="readOnly"
    >
      <template v-slot:invalidTag>
        聯絡電郵無效，請輸入一個有效的聯絡電郵
      </template>
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.contactPhone"
                       :fieldName="'contactPhone'"
                       label="聯絡電話"
                       name="聯絡電話"
                       rules="required|numeric|min:6|max:12"
                       type="text"
                       disabled
                       required
                       :readOnly="readOnly || !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.contactName"
                       :fieldName="'contactName'"
                       label="聯絡人名稱"
                       name="聯絡人名稱"
                       rules="required|max:15"
                       type="text"
                       disabled
                       required
                       :readOnly="readOnly || !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
  </div>
</template>

<script>
import AGCEditGroupInput from '../form/AGCEditGroupInput.vue';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  props: {
    role: String,
    readOnly: Boolean,
  },
  components: {
    AGCEditGroupInput,
  },
  data: () => ({
    classOptions: [
      { value: 'NORMAL', text: '普通商戶' },
      { value: 'PREMIUM', text: '星級商戶' },
    ],
    regEx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  }),
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .custom-dropdown {
      .custom-select {
        width: auto;
        font-size: 0.98em;
      }
    }
  }
</style>
